var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinilogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 285",
    width: 220,
    height: 285,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #fcb813 } \n\t\t.shp1 { fill: #0066b2 } \n\t\t.shp2 { fill: #ffffff } \n\t\t.shp3 { fill: #c3161c } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "shp0",
    d: "M126.4 37.5C94.1 55.3 59.2 86.1 48.4 132.2C36.2 184.3 58.4 219.4 102.3 251.3L83.7 241.2C42.7 219.4 20.8 192.1 21 142.3C21.2 74.9 105.1 12.3 163.1 17.3C138.6 18.3 126.4 37.5 126.4 37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "shp1",
    d: "M120.4 78.1C16.7 163.5 115.9 259.5 115.9 259.5C86 242.5 62.9 221.2 52 194C30.5 140.9 61.3 71 126.4 37.5C112 55.8 120.4 78.1 120.4 78.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "shp2",
    d: "M62.5 124.1L65.4 126.7L69.2 125.8L67.5 129.3L69.5 132.6L65.7 132.2L63.1 135L62.3 131.3L58.7 129.8L62.1 127.8L62.5 124.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "shp2",
    d: "M70 103.4L74.1 105.4L78.2 103.2L77.5 107.7L80.9 110.9L76.3 111.6L74.3 115.7L72.1 111.7L67.5 111.1L70.8 107.9L70 103.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "shp2",
    d: "M78.6 90L82.9 87.1L82.9 82L87 85.1L92 83.6L90.3 88.3L93.3 92.4L88.1 92.3L85 96.4L83.6 91.5L78.6 90Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "shp2",
    d: "M94.9 72.4L100 69L100 63L104.9 66.7L110.8 65L108.6 70.6L112.2 75.5L106.1 75.3L102.4 80.1L100.7 74.3L94.9 72.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "shp2",
    d: "M61.4 145.7L62.5 148.8L65.7 149.8L62.9 151.7L63 155L60.3 153.1L57 154.2L58.1 151L56.1 148.3L59.5 148.4L61.4 145.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "shp2",
    d: "M57.6 167.2L60.3 169.1L63.5 168L62.5 171.1L64.6 173.7L61.2 173.7L59.4 176.4L58.3 173.3L55.1 172.4L57.8 170.5L57.6 167.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "shp2",
    d: "M62.6 188.8L64.7 190.7L67.5 190.1L66.3 192.7L67.8 195L64.9 194.7L63 196.8L62.5 194L59.8 192.9L62.4 191.6L62.6 188.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "shp2",
    d: "M70.8 206.5L72.3 208.6L74.8 208.7L73.1 210.6L73.8 213L71.5 212.1L69.4 213.4L69.5 211L67.5 209.4L70 208.8L70.8 206.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "shp3",
    d: "M135.9 100.1C125 107.8 115.2 117.5 108.6 129.8C72.6 197.4 133.4 269.1 133.4 269.1L115.8 259.4C115.8 259.4 45.8 203.3 83.3 121.2C92.1 102 102.5 89.6 120.4 78C125.9 94.3 135.9 100.1 135.9 100.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "shp3",
    d: "M198.6 64C198.6 79.1 186 91.4 170.5 91.4C154.9 91.4 142.3 79.1 142.3 64C142.3 48.8 154.9 36.5 170.5 36.5C186 36.5 198.6 48.9 198.6 64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "shp3",
    d: "M183.8 111.8L183.8 268.8L157.2 268.8L157.2 111.8C157.1 111.8 169.2 118.1 183.8 111.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinilogo);
export default __webpack_public_path__ + "static/media/minilogo.0c67fbeb6607d41cad958e37185c9a80.svg";
export { ForwardRef as ReactComponent };